module.exports = __webpack_public_path__ + "img/title_lecture.cef5613b.png";